import React, { Component } from 'react'
import { PageContainerLayout, PageHeaderLayout } from '../../../layouts'
import { AlarmWizardForm } from '../../containers/alarm-wizard-form'
import { NavLink } from 'react-router-dom'
import * as ROUTING_PATHS from '../../../../routing/Paths'
import { AlarmShape } from '../../../../prop-types'
import * as PropTypes from 'prop-types'
import { alarmOperations } from '../../../../state/ducks/alarms'
import { connect } from 'react-redux'
import { Session } from '../../../../state/utils/session'

class AlarmEditorPage extends Component {
  constructor (props) {
    super(props)

    this.state = {
      session: new Session()
    }

    this.renderHeaderPaths = this.renderHeaderPaths.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.props.getAlarm(this.props.match.params.alarm_id)
  }

  renderHeaderPaths () {
    return (
            <>
                <li>
                    <NavLink className="link-effect"
                             to={ROUTING_PATHS.CLIENT_DASHBOARD_ALARMS_PATH.replace(':client_id', this.state.session.getClientSession())}
                    >
                        Alarms
                    </NavLink>
                </li>
                <li>Edit Alarm</li>
            </>
    )
  }

  render () {
    return (
            <>
                <PageContainerLayout clientSidebar={true} showNavbarClientOptions={true}>
                    <PageHeaderLayout
                        title={this.props.alarm.name}
                        subTitle={'Edit Alarm'}
                        paths={this.renderHeaderPaths}
                    />
                    <AlarmWizardForm
                        alarm={this.props.alarm}
                        isEditor={true}
                    />
                </PageContainerLayout>
            </>
    )
  }
}

// Set propTypes
AlarmEditorPage.propTypes = {
  alarm: AlarmShape,
  getAlarmErrorResponse: PropTypes.object
}

// Set defaultProps
AlarmEditorPage.defaultProps = {
  alarm: {},
  getAlarmErrorResponse: {}
}

// mapStateToProps
const mapStateToProps = (state) => ({
  alarm: state.alarms.getAlarmReducer.data,
  isLoading: state.alarms.getAlarmReducer.loading,
  getAlarmErrorResponse: state.alarms.getAlarmReducer.error_data
})

// mapStateToProps
const mapDispatchToProps = {
  getAlarm: alarmOperations.get
}

// Export Class
const _AlarmEditorPage = connect(mapStateToProps, mapDispatchToProps)(AlarmEditorPage)
export { _AlarmEditorPage as AlarmEditorPage }
